import React from 'react';
import styles from './local-items-separator.module.scss';

/**
 * Presentational separator shown inside a mirrored category between
 * source-derived children (above) and user-added local children (below).
 *
 * - `label`: pre-formatted text to render in the middle of the divider.
 * - `dropRef`: attaches a react-dnd drop ref to the root so callers can wire
 *   custom drop behavior (e.g. snap-back). Optional.
 */
export function LocalItemsSeparator({ label, dropRef }) {
  return (
    <div ref={dropRef} className={styles.separator} aria-hidden="true">
      <span className={styles.line} />
      <span className={styles.label}>{label}</span>
      <span className={styles.line} />
    </div>
  );
}
